// src/components/StatsCard.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye } from "lucide-react";

export default function StatsCard({ title, value, color, navigationPath }) {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleViewMore = () => {
    if (navigationPath) {
      navigate(navigationPath);
    }
  };

  return (
    <div 
      className={`p-4 rounded-xl text-white shadow transition-all duration-300 transform hover:scale-105 hover:shadow-lg relative overflow-hidden cursor-pointer ${color}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleViewMore}
    >
      <div className="text-base opacity-80">{title}</div>
      <div className="text-3xl font-bold">{value}</div>
      
      {/* View More Overlay */}
      {isHovered && navigationPath && (
        <div className="absolute top-1 right-1 transition-all duration-300">
          <div className="bg-white/15 dark:bg-black/25 backdrop-blur-sm text-white dark:text-gray-200 px-1.5 py-0.5 rounded flex items-center gap-0.5 text-xs font-medium shadow-sm border border-white/15 dark:border-gray-600/25" style={{ fontSize: '0.65rem' }}>
            <Eye size={10} />
            <span>View</span>
          </div>
        </div>
      )}
      
      {/* Subtle gradient overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-br from-white from-0% to-transparent to-50% opacity-10 pointer-events-none"></div>
    </div>
  );
}
